module.exports = __webpack_public_path__ + "static/media/desktop.14d8646.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/MagazineSpyglass/desktop.mp4
// module id = uEYD
// module chunks = 1